export default class Onboarding {
    static handleSelectOptionClick(idx, type, setSelectedOptionCb){
        setSelectedOptionCb({
                ...type,
                index: idx,
        });
    }
}